export default __webpack_public_path__ + "static/media/DNo.21-1.114c4d0c.jpg";